import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTypePieChart, getCategoryCost as _getCategoryCost, getTypeCategoryExport } from '../api';
import { isNumber } from '@/utils';
export default {
  name: 'order-consume-business',
  props: {
    is_total: [Number, String],
    searchData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      activeName: '1',
      activeNameChart: '1',
      tabList: [{
        label: '消费分类统计',
        name: '1'
      }, {
        label: '商城菜单统计',
        name: '2'
      }],
      orderTypeList: [],
      //订单类型消费占比
      businessTypeList: [],
      //业务类型消费占比
      consumeScenarioList: [],
      //消费场景占比

      categoryCostList: [],
      // 商城菜单统计 - 列表
      categoryCostPaging: {
        page: 1,
        page_size: 20,
        totalCount: 0
      },
      // gross_profit_type: '', // 订单金额  0:应收 1:实收 2:已售
      cardInfo: {},
      cardInfoList: [{
        label: '卡类型名称',
        value: 'name'
      }, {
        label: '卡类型ID',
        value: 'card_bin_id'
      }, {
        label: '商城展示名称',
        value: 'shop_name'
      }, {
        label: '业务类型',
        value: 'type'
      }, {
        label: '应收',
        value: 'shou_money'
      }, {
        label: '实收',
        value: 'finance_money'
      }, {
        label: '售卡点数',
        value: 'card_sale_points'
      }, {
        label: '消费点数',
        value: 'consume_points'
      }, {
        label: '剩余点数',
        value: 'available_points'
      }],
      grossList: [[{
        label: '消费率',
        formatter: function formatter() {
          return _this.cardInfo.consume_rate + '%';
        }
      }, {
        label: '留存率',
        formatter: function formatter() {
          return _this.cardInfo.available_rate + '%';
        }
      }, {
        label: '绑卡率',
        formatter: function formatter() {
          return _this.cardInfo.bind_card_rate + '%';
        }
      }, {
        label: '全留率',
        formatter: function formatter() {
          return _this.cardInfo.un_use_card_rate + '%';
        }
      }, {
        label: '零留率',
        formatter: function formatter() {
          return _this.cardInfo.zero_card_rate + '%';
        }
      }, {
        label: '推测留存率',
        formatter: function formatter() {
          return _this.cardInfo.prediction_available_rate + '%';
        }
      }], [{
        label: '含留存毛利',
        value: 'gross_profit'
      }, {
        label: '含留存毛利率',
        formatter: function formatter() {
          var gross_profit_rate = _this.cardInfo.gross_profit_rate;
          if (isNumber(gross_profit_rate, true)) {
            return gross_profit_rate + '%';
          }
          return gross_profit_rate;
        }
      }, {
        label: '不含留存毛利',
        value: 'consume_gross_profit'
      }, {
        label: '不含留存毛利率',
        formatter: function formatter() {
          var consume_gross_profit_rate = _this.cardInfo.consume_gross_profit_rate;
          if (isNumber(consume_gross_profit_rate, true)) {
            return consume_gross_profit_rate + '%';
          }
          return consume_gross_profit_rate;
        }
      }, {
        label: '推测含留存毛利',
        value: 'prediction_gross_profit'
      }, {
        label: '推测含留存毛利率',
        formatter: function formatter() {
          var prediction_gross_profit_rate = _this.cardInfo.prediction_gross_profit_rate;
          if (isNumber(prediction_gross_profit_rate, true)) {
            return prediction_gross_profit_rate + '%';
          }
          return prediction_gross_profit_rate;
        }
      }]]
    };
  },
  methods: {
    // 商城菜单统计 - 导出
    onClickCategoryExport: function onClickCategoryExport() {
      var _this2 = this;
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.searchData), this.categoryCostPaging), {}, {
        is_total: this.is_total
      });
      getTypeCategoryExport(params).then(function (res) {
        if (res.data) {
          _this2.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
        }
      });
    },
    changeCategoryCostPage: function changeCategoryCostPage(val) {
      this.categoryCostPaging.page = val;
      this.getCategoryCost(false);
    },
    getCategoryCost: function getCategoryCost() {
      var _this3 = this;
      var draw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      _getCategoryCost(_objectSpread(_objectSpread(_objectSpread({}, this.searchData), this.categoryCostPaging), {}, {
        is_total: this.is_total
      })).then(function (res) {
        var _res$data = res.data,
          _res$data$list = _res$data.list,
          list = _res$data$list === void 0 ? [] : _res$data$list,
          _res$data$total = _res$data.total,
          total = _res$data$total === void 0 ? {} : _res$data$total;
        _this3.categoryCostList = list;
        if (_this3.categoryCostList.length > 0) {
          _this3.categoryCostList.unshift(_objectSpread(_objectSpread({}, total), {}, {
            category_name: '总计',
            name: '-'
          }));
        }
        _this3.categoryCostPaging.totalCount = res.pages.totalCount;
      });
      if (draw) {
        _getCategoryCost(_objectSpread(_objectSpread(_objectSpread({}, this.searchData), this.categoryCostPaging), {}, {
          is_total: this.is_total
        }), 'pie').then(function (res) {
          var pie = res.data.list.map(function (i) {
            return {
              name: i.category_name,
              occupancy: i.occupancy
            };
          });
          _this3.$nextTick(function () {
            _this3.initEchart(pie, 'category_cost');
          });
        });
      }
    },
    changeTab: function changeTab() {
      // 获取图表数据并重新绘制
      var cb = {
        1: this.loadData,
        2: this.getCategoryCost
      }[this.activeNameChart];
      typeof cb === 'function' && cb();
    },
    columns: function columns(type) {
      return [{
        label: {
          order: '商城订单类型',
          business: '业务类型',
          consume: '消费场景'
        }[type],
        prop: 'name'
      }, {
        label: '消费点数',
        prop: 'amount'
      }, {
        label: '消费占比',
        prop: 'occupancy',
        formatter: function formatter(row, _, cellValue) {
          return cellValue + '%';
        }
      }, {
        label: '成本率',
        prop: 'cost_occupancy',
        formatter: function formatter(row, _, cellValue) {
          return cellValue + '%';
        }
      }];
    },
    initEchart: function initEchart(data, type) {
      var seriesData = data.filter(function (i) {
        return i.name !== '总计';
      }) // 后端要求根据该名字删除掉总计数据绘图
      .map(function (i) {
        return {
          value: i.occupancy,
          name: i.name
        };
      });
      var chartDom = this.$refs["datascren_".concat(type)];
      var myChart = this.$echarts.init(chartDom);
      var tag_type = this.searchData.tag_type;
      var title = {
        order: '订单类型消费',
        business: '业务类型消费',
        consume: '消费场景'
      }[type] + '占比';
      if (type === 'category_cost') {
        title = '商城菜单统计';
      }
      var option = {
        title: {
          text: title,
          x: 'center'
        },
        legend: {
          icon: 'circle',
          // 修改形状
          itemHeight: 6,
          // 修改icon图形大小
          itemGap: 5,
          // 修改间距
          textStyle: {
            color: '#333',
            fontSize: 10,
            padding: [0, 0, 0, -12] // 修改文字和图标距离
          },
          top: '30px'
        },
        grid: {
          top: '0'
        },
        tooltip: {
          trigger: 'item',
          valueFormatter: function valueFormatter(value) {
            return value + '%';
          },
          confine: true // 是否将 tooltip 框限制在图表的区域内。
        },
        // toolbox: {
        // 	feature: {
        // 		dataView: { show: false, readOnly: false },
        // 		magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
        // 		restore: { show: true },
        // 		saveAsImage: { show: true }
        // 	}
        // },
        series: [{
          type: 'pie',
          radius: '50%',
          label: {
            formatter: "{b}{c}%"
          },
          data: seriesData
        }]
      };
      option && myChart.setOption(option);
    },
    loadData: function loadData(type) {
      var _this4 = this;
      var tag_type = this.searchData.tag_type;
      getTypePieChart(_objectSpread(_objectSpread({}, this.searchData), {}, {
        is_total: this.is_total
      }), tag_type).then(function (res) {
        var _res$data2 = res.data,
          _res$data2$order_type = _res$data2.order_type,
          order_type = _res$data2$order_type === void 0 ? [] : _res$data2$order_type,
          _res$data2$business_t = _res$data2.business_type,
          business_type = _res$data2$business_t === void 0 ? [] : _res$data2$business_t,
          _res$data2$consume_sc = _res$data2.consume_scenario,
          consume_scenario = _res$data2$consume_sc === void 0 ? [] : _res$data2$consume_sc,
          _res$data2$order = _res$data2.order,
          order = _res$data2$order === void 0 ? {} : _res$data2$order;
        // if (type === 'update_gross') {
        // 	this.cardInfo = order
        // 	return
        // }
        _this4.orderTypeList = order_type;
        _this4.businessTypeList = business_type;
        _this4.consumeScenarioList = consume_scenario;
        _this4.cardInfo = order;
        _this4.$nextTick(function () {
          _this4.initEchart(order_type, 'order');
          _this4.initEchart(business_type, 'business');
          _this4.initEchart(consume_scenario, 'consume');
        });
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};